/**
 * Application Constants
 * Centralized configuration for branding and app information
 * Update these values to change app branding across the entire application
 */

export const APP_CONFIG = {
  // App/Product Name
  appName: 'Meri Gaadi',
  
  // Company Name
  company: 'Vionex Labs',
  
  // App Description
  description: 'Fleet Management System',
  
  // Copyright Year
  copyrightYear: 2025,
  
  // Full branding strings
  get fullBrand() {
    return `${this.appName} - ${this.description}`;
  },
  
  get copyright() {
    return `© ${this.copyrightYear} ${this.company}`;
  },
};

// Export individual constants for convenience
export const {
  appName,
  company,
  description,
  copyrightYear,
} = APP_CONFIG;
